import React from "react";

/**
 * A hand-drawn sine wave used as a soft end-line under paragraph text.
 * Width scales with parent, height is fixed at 10px. `stroke` uses currentColor
 * so it inherits from the paragraph text colour.
 */
export default function WavyEnd({ className = "", width = 160 }) {
  return (
    <svg
      aria-hidden
      data-testid="wavy-end"
      viewBox="0 0 160 10"
      width={width}
      height="10"
      className={`block mt-3 opacity-60 ${className}`}
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      preserveAspectRatio="none"
    >
      <path d="M 2 5 Q 12 0, 22 5 T 42 5 T 62 5 T 82 5 T 102 5 T 122 5 T 142 5 T 158 5" />
    </svg>
  );
}
